import {
    UserOutlined,
    CloseOutlined,
    QrcodeOutlined,
    EditOutlined,
    SaveOutlined,
    BarcodeOutlined,
    UnorderedListOutlined,
    ClockCircleOutlined,
    SettingOutlined,
    PhoneOutlined,
    SecurityScanOutlined,
    UploadOutlined,
    FolderOpenOutlined,
    LoadingOutlined,
    SyncOutlined,
    WarningFilled,
    CopyOutlined,
    MessageOutlined,
    ShareAltOutlined,
    UsergroupAddOutlined,
    DeleteOutlined,
    VideoCameraFilled,
    AlertFilled,
    AlignLeftOutlined,
    AlignCenterOutlined,
    AlignRightOutlined,
} from "@ant-design/icons";
import { SearchOutlined, FilterFilled, CalendarOutlined, FilterOutlined } from "@ant-design/icons";
import { LoginOutlined, MenuOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { DownloadOutlined } from "@ant-design/icons";
import { IoBriefcaseSharp, IoCalendarNumberOutline, IoTrashBinOutline, IoSettingsOutline } from "react-icons/io5";
import { GiArtificialIntelligence, GiCancel, GiForestCamp, GiPayMoney } from "react-icons/gi";
import { GrLocation, GrMoney, GrBottomCorner } from "react-icons/gr";
import { LiaExchangeAltSolid, LiaPencilRulerSolid } from "react-icons/lia";
import { MdFindReplace, MdLocationCity, MdOutlineDashboardCustomize, MdOutlineSick, MdOutlineSupportAgent, MdRestoreFromTrash, MdSubject } from "react-icons/md";
import {
    FaCheck,
    FaDollarSign,
    FaFileInvoiceDollar,
    FaHistory,
    FaQuestion,
    FaRegThumbsUp,
    FaTrash,
    FaFirstdraft,
    FaRegFilePdf,
    FaRegFileWord,
    FaRegFileAlt
} from "react-icons/fa";
import { IoIosBusiness } from "react-icons/io";
import { BsBank, BsClipboardCheck, BsLayoutSidebarInset, BsLayoutSidebarInsetReverse, BsLayoutThreeColumns } from "react-icons/bs";
import { BiFolderOpen } from "react-icons/bi";
import { LuLayoutTemplate, LuLogs } from "react-icons/lu";
import { TbCategoryPlus, TbContract, TbLogs, TbReportSearch } from "react-icons/tb";
import { AiFillOpenAI, AiOutlineProfile } from "react-icons/ai";
import { ImPhoneHangUp } from "react-icons/im";
import { PiOfficeChair } from "react-icons/pi";
import { RiEqualizer2Fill, RiEqualizer2Line } from "react-icons/ri";
import { FaBuilding, FaFile, FaFileCirclePlus, FaFileContract, FaFileSignature, FaFolderClosed, FaGear, FaReceipt, FaUserTie } from "react-icons/fa6"
import Logo from "./Logo";
import { VscDiffRemoved, VscTypeHierarchySub, VscWordWrap } from "react-icons/vsc";

const iconMapping = new Map();
iconMapping.set("menu.users", UserOutlined );
iconMapping.set("menu.companyUsers", UserOutlined );
iconMapping.set("menu.parties", FaUserTie );
iconMapping.set("menu.tasks", UnorderedListOutlined );
iconMapping.set("menu.tenants", MdLocationCity );
iconMapping.set("menu.companies", MdLocationCity );
iconMapping.set("menu.company", IoIosBusiness );
iconMapping.set("menu.companyInfo", IoIosBusiness );
iconMapping.set("menu.contractsSection", FaFileContract );
iconMapping.set("menu.contracts", FaFileSignature );
iconMapping.set("menu.contractTemplates", FaFileCirclePlus );
iconMapping.set("menu.calendar", IoCalendarNumberOutline );
iconMapping.set("menu.clientCalendar", IoCalendarNumberOutline );
iconMapping.set("menu.home", Logo );
iconMapping.set("menu.activities", ClockCircleOutlined );
iconMapping.set("menu.bankAccounts", BsBank );
iconMapping.set("menu.settings", FaGear );
iconMapping.set("menu.allCommunications", PhoneOutlined );
iconMapping.set("menu.clientCommunication", PhoneOutlined );
iconMapping.set("menu.communications", TbLogs );
iconMapping.set("menu.chat", MessageOutlined );
iconMapping.set("menu.invoices", FaFileInvoiceDollar );
iconMapping.set("menu.taskActivityCategories", TbCategoryPlus );
iconMapping.set("menu.paymentProfiles", AiOutlineProfile );
iconMapping.set("menu.vat", GiPayMoney );
iconMapping.set("menu.vatCountries", GrMoney );
iconMapping.set("menu.vatCategories", GrMoney );
iconMapping.set("menu.vatSettings", GrMoney );
iconMapping.set("menu.securityGroups", SecurityScanOutlined );
iconMapping.set("menu.filesAndFolders", FaFolderClosed );
iconMapping.set("menu.sync", SyncOutlined );
iconMapping.set("menu.histories", FaHistory );
iconMapping.set("menu.customFields", MdOutlineDashboardCustomize );
iconMapping.set("menu.clientPortals", MdOutlineSupportAgent );
iconMapping.set("menu.userGroups", UsergroupAddOutlined );
iconMapping.set("menu.recycleBin", DeleteOutlined );
iconMapping.set("menu.businessObjects", FaBuilding );
iconMapping.set("menu.events", IoCalendarNumberOutline );
iconMapping.set("menu.sickLeaves", MdOutlineSick );
iconMapping.set("menu.vacations", GiForestCamp );
iconMapping.set("menu.alerts", AlertFilled );
iconMapping.set("menu.contractTypes", VscTypeHierarchySub);
iconMapping.set("menu.contractObjects", MdSubject);
iconMapping.set("menu.drafts", FaFirstdraft);
iconMapping.set("menu.quality", RiEqualizer2Fill);
iconMapping.set("menu.qualityControlScores", RiEqualizer2Line);
iconMapping.set("menu.qualityControlRules", LiaPencilRulerSolid);
iconMapping.set("menu.aiPrompts", AiFillOpenAI);
iconMapping.set("menu.logs", LuLogs);

iconMapping.set("user", UserOutlined );
iconMapping.set("userGroup", UsergroupAddOutlined );
iconMapping.set("party", UserOutlined );
iconMapping.set("task", UnorderedListOutlined );
iconMapping.set("company", MdLocationCity );
iconMapping.set("research", TbReportSearch );
iconMapping.set("board", BsClipboardCheck );
iconMapping.set("businessObject", PiOfficeChair );
iconMapping.set("matter", IoBriefcaseSharp );
iconMapping.set("activity", ClockCircleOutlined );
iconMapping.set("bankAccount", BsBank );
iconMapping.set("communication", PhoneOutlined );
iconMapping.set("invoice", FaReceipt );
iconMapping.set("filesAndFolders", FolderOpenOutlined );
iconMapping.set("gridCustomField", MdOutlineDashboardCustomize );
iconMapping.set("chat", MessageOutlined );
iconMapping.set("company", MdLocationCity );
iconMapping.set("search", SearchOutlined );
iconMapping.set("gridFilter", FilterFilled );
iconMapping.set("calendar", CalendarOutlined );
iconMapping.set("default", CloseOutlined );
iconMapping.set("location", GrLocation );
iconMapping.set("qrCode", QrcodeOutlined );
iconMapping.set("impersonate", LoginOutlined );
iconMapping.set("edit", EditOutlined );
iconMapping.set("remove", FaTrash );
iconMapping.set("menu", MenuOutlined );
iconMapping.set("shoppingCart", ShoppingCartOutlined );
iconMapping.set("filter", FilterOutlined );
iconMapping.set("open", BiFolderOpen );
iconMapping.set("download", DownloadOutlined );
iconMapping.set("ok", FaCheck );
iconMapping.set("cancel", GiCancel );
iconMapping.set("save", SaveOutlined );
iconMapping.set("barcode", BarcodeOutlined );
iconMapping.set("upload", UploadOutlined );
iconMapping.set("loading", LoadingOutlined );
iconMapping.set("money", FaDollarSign );
iconMapping.set("phone", PhoneOutlined );
iconMapping.set("phoneEnd", ImPhoneHangUp );
iconMapping.set("forApprove", FaQuestion );
iconMapping.set("approve", FaRegThumbsUp );
iconMapping.set("warning", WarningFilled );
iconMapping.set("copy", CopyOutlined);
iconMapping.set("share", ShareAltOutlined);
iconMapping.set("video", VideoCameraFilled);
iconMapping.set("restore", MdRestoreFromTrash);
iconMapping.set("emptyTrash", IoTrashBinOutline);
iconMapping.set("settings", IoSettingsOutline);
iconMapping.set("bottomCorner", GrBottomCorner);
iconMapping.set("layout3Columns", BsLayoutThreeColumns);
iconMapping.set("sidebarInsert", BsLayoutSidebarInset);
iconMapping.set("sidebarInsertReverse", BsLayoutSidebarInsetReverse);
iconMapping.set("wordWrap", VscWordWrap);
iconMapping.set("alignLeft", AlignLeftOutlined);
iconMapping.set("alignCenter", AlignCenterOutlined);
iconMapping.set("alignRight", AlignRightOutlined);
iconMapping.set("filePdf", FaRegFilePdf);
iconMapping.set("fileWord", FaRegFileWord);
iconMapping.set("fileRegular", FaRegFileAlt);
iconMapping.set("deduplication", VscDiffRemoved);
iconMapping.set("replace", MdFindReplace);
iconMapping.set("exchange", LiaExchangeAltSolid);

interface IOptions {
    def?: boolean
    size?: number
    color?: string
}

const Icon = (name: string, options?: IOptions) => {
    const IconComponent = iconMapping.get(name) || (options?.def ? iconMapping.get("default") : null)
    return  IconComponent? <IconComponent 
        {...options?.color && {color: options.color}}
        {...options?.size && {size: options.size}}
    /> : null
}

export default Icon
